import store from './react_app/redux';

import { updateBreadcrumbTitle } from './react_app/components/BreadcrumbBar/BreadcrumbBarActions';

export const updateTitle = title =>
  store.dispatch(updateBreadcrumbTitle(title));



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/foreman_breadcrumbs.js